/** @file viewMenu: View: panels, Grid, Quads, Onion skin, Zoom in/out, Reset view, Turntable. */
import type { PanelName } from '../state/editorTypes';
import type { BarItem, MenuBuilder } from './menuTypes';
import { viewportCanvas } from './viewportCanvas';
import { zoomViewport } from './zoomViewport';

const PANELS: { name: PanelName; label: string }[] = [
  { name: 'tree', label: 'Node tree' }, { name: 'inspector', label: 'Inspector' }, { name: 'timeline', label: 'Timeline' },
];

/** View rows: a check mark shows each toggle that is on; the zoom rows need the Pose viewport on screen. */
export const viewMenu: MenuBuilder = (ctx) => {
  const s = ctx.store.getState();
  const panels: BarItem[] = PANELS.map(({ name, label }) => ({
    kind: 'item', id: `view.${name}`, label, checked: s.shell.panels[name],
    onSelect: () => { const now = ctx.store.getState().shell; s.setShell({ panels: { ...now.panels, [name]: !now.panels[name] } }); },
  }));
  const noViewport = viewportCanvas() === null;
  return [
    ...panels,
    { kind: 'separator' },
    { kind: 'item', id: 'view.grid', label: 'Grid', chord: ctx.chordOf('viewport.grid.toggle'), checked: s.camera.grid, onSelect: () => { s.setCamera({ grid: !ctx.store.getState().camera.grid }); } },
    { kind: 'item', id: 'view.quads', label: 'Quads', chord: ctx.chordOf('viewport.quads.toggle'), checked: s.camera.quads, onSelect: () => { s.setCamera({ quads: !ctx.store.getState().camera.quads }); } },
    { kind: 'item', id: 'view.onion', label: 'Onion skin', checked: s.camera.onion > 0, onSelect: () => { s.setCamera({ onion: ctx.store.getState().camera.onion > 0 ? 0 : 1 }); } },
    { kind: 'separator' },
    { kind: 'item', id: 'view.zoomIn', label: 'Zoom in', disabled: noViewport, hint: 'Same as the wheel', onSelect: () => { zoomViewport('in'); } },
    { kind: 'item', id: 'view.zoomOut', label: 'Zoom out', disabled: noViewport, hint: 'Same as the wheel', onSelect: () => { zoomViewport('out'); } },
    {
      kind: 'item', id: 'view.reset', label: 'Reset view', chord: ctx.chordOf('viewport.camera.reset'),
      hint: 'Yaw and pitch back to the profile camera',
      onSelect: () => { s.setCamera({ yawDeg: 0, pitchDeg: ctx.store.getState().preview.bundle?.profile.camera.pitch ?? 30 }); },
    },
    { kind: 'item', id: 'view.turntable', label: 'Turntable', checked: s.shell.turntable, onSelect: () => { s.setShell({ turntable: !ctx.store.getState().shell.turntable }); } },
  ];
};
